const RadioInputGroup = (props) => {
  const input = props.options
    .map((option, idx) => <label className='radio-inline'>
      <input type={'radio'}
        name={props.name}
        className={`qa-${option}`}
        required={props.required}
        disabled={props.disabled}
        onChange={() => props.onChange(option, idx)}
        checked={option === props.value} />
      {option}
    </label>)
    .reduce((prev, curr) => prev.concat([' ', curr]), [])

  return <div className={`form-group ${props.title ? 'qa-' + props.title.split(' ').join('') : ''}`}>
    {
      props.title ? <label>{props.title}</label> : null
    }
    {
      props.meta ? props.meta : null
    }
    <div className={'radio-group'}>
      {input}
    </div>
  </div>
}

export default RadioInputGroup
